import React, { useState } from "react";
import { Typography, Row, Col, Card } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import businessSuiteOfferings from "../../data/businessSuiteOfferings";

const { Title, Text, Paragraph } = Typography;

const primaryColor = "#3C007A";

// A rotating accent palette so each card in the catalog gets its own identity
const accentPalette = [
  { color: "#3C007A", bg: "#f0ebf8" },
  { color: "#eb2f96", bg: "#fff0f6" },
  { color: "#1890ff", bg: "#e6f7ff" },
  { color: "#fa8c16", bg: "#fff7e6" },
  { color: "#52c41a", bg: "#f6ffed" },
  { color: "#13c2c2", bg: "#e6fffb" },
  { color: "#722ed1", bg: "#f9f0ff" },
  { color: "#f5222d", bg: "#fff1f0" },
  { color: "#faad14", bg: "#fffbe6" },
  { color: "#2f54eb", bg: "#f0f5ff" },
  { color: "#eb2f96", bg: "#fff0f6" },
];

export default function BusinessSuiteCatalog() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div style={{ fontFamily: "'Rubik', sans-serif" }}>
      {/* Hero Header */}
      <div
        style={{
          background: `linear-gradient(135deg, ${primaryColor} 0%, #6b0fa0 100%)`,
          padding: "40px 32px",
          marginBottom: 32,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: -60,
            right: -60,
            width: 220,
            height: 220,
            background: "rgba(255,255,255,0.08)",
            borderRadius: "50%",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -40,
            left: "30%",
            width: 160,
            height: 160,
            background: "rgba(255,255,255,0.06)",
            borderRadius: "50%",
          }}
        />

        <div style={{ position: "relative", zIndex: 1, display: "flex", alignItems: "center", gap: 16 }}>
          <div
            style={{
              width: 96,
              height: 96,
              borderRadius: 16,
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              // padding: 14,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src="/img/bo_logo.png"
              alt="Bharat Online"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </div>
          <div>
            <Title
              level={2}
              style={{ margin: 0, fontFamily: "'Rubik', sans-serif", color: "#fff", fontWeight: 700 }}
            >
              Bharat Online Business Suite
            </Title>
            <Text style={{ fontSize: 15, color: "rgba(255,255,255,0.9)" }}>
               More Than Membership. A Toolkit for Your Next Opportunity
            </Text>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 32px 32px" }}>
        <Row gutter={[24, 24]}>
          {businessSuiteOfferings.map((item, index) => {
            const accent = accentPalette[index % accentPalette.length];
            const isHovered = hoveredIndex === index;

            return (
              <Col xs={24} sm={12} lg={8} key={`${item.path}-${index}`}>
                <Card
                  bordered={false}
                  onClick={() => window.open(item.path, "_blank", "noopener,noreferrer")}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{
                    borderRadius: 16,
                    height: "100%",
                    cursor: "pointer",
                    overflow: "hidden",
                    boxShadow: isHovered
                      ? `0 12px 28px ${accent.color}33`
                      : "0 2px 12px rgba(0,0,0,0.06)",
                    transform: isHovered ? "translateY(-6px)" : "translateY(0)",
                    transition: "all 0.25s ease",
                    border: `1px solid ${isHovered ? accent.color : "#f0f0f0"}`,
                  }}
                  bodyStyle={{ padding: 0 }}
                >
                  <div style={{ padding: "24px", display: "flex", flexDirection: "column", height: "100%" }}>
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: 14,
                        background: accent.bg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 20,
                        boxShadow: `0 4px 12px ${accent.color}20`,
                      }}
                    >
                      {item.icon(accent.color)}
                    </div>

                    <Title
                      level={4}
                      style={{ margin: 0, marginBottom: 8, fontFamily: "'Rubik', sans-serif", color: "#262626" }}
                    >
                      {item.label}
                    </Title>

                    <Paragraph
                      type="secondary"
                      style={{ flex: 1, marginBottom: 20, fontSize: 14, lineHeight: 1.6 }}
                    >
                      {item.description}
                    </Paragraph>

                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        alignSelf: "flex-start",
                        padding: "8px 16px",
                        borderRadius: 20,
                        background: isHovered ? accent.color : accent.bg,
                        color: isHovered ? "#fff" : accent.color,
                        fontWeight: 600,
                        fontSize: 14,
                        fontFamily: "'Rubik', sans-serif",
                        transition: "all 0.25s ease",
                      }}
                    >
                      Join Us <ArrowRightOutlined style={{ fontSize: 12 }} />
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
}
